// extracted by mini-css-extract-plugin
export default {"HomeBrokers":"home_HomeBrokers__kWd8t","HomeEmployees":"home_HomeEmployees__KwN0H"};